import { render, staticRenderFns } from "./MyCartButton.vue?vue&type=template&id=ef4bab66&scoped=true"
import script from "./MyCartButton.vue?vue&type=script&lang=js"
export * from "./MyCartButton.vue?vue&type=script&lang=js"
import style0 from "./MyCartButton.vue?vue&type=style&index=0&id=ef4bab66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4bab66",
  null
  
)

export default component.exports